module.exports = __webpack_public_path__ + "img/HomeNCC2040.4bdf542c.png";